import { useRef, useState, useEffect } from 'react';
import bem from '../../../utils/bem';
import Icon from '../../Atoms/Icon/Icon';

const SortBy = ({
  sortByState,
  sortByOptions = [],
  setSortByState,
  showSelected = false,
}) => {
  const listRef = useRef(null);
  const [menuState, setMenuState] = useState(false);

  const handleClickOutside = (event) => {
    if (listRef.current && !listRef.current.contains(event.target)) {
      setMenuState(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [listRef]);

  if (!sortByState || !setSortByState || !sortByOptions.length) {
    return '';
  }

  const sortByBaseClass = 'sort-by';

  return (
    <div className={bem(sortByBaseClass, [], '', ['relative'])} ref={listRef}>
      <button
        className={bem('switcher', [], sortByBaseClass, [
          'flex',
          'btn-icon',
          'items-center',
        ])}
        onClick={() => setMenuState(!menuState)}
      >
        {Drupal.t('Sort by')}
        {showSelected &&
          `: ${
            sortByOptions.find((opt) => opt.value === sortByState)?.label ||
            Drupal.t('Default')
          }`}
        <Icon iconName="chevron" />
      </button>

      {menuState && (
        <ul
          className={bem('options', [], sortByBaseClass, ['flex', 'flex-col'])}
          role="list"
        >
          {sortByOptions.map((option) => {
            return (
              <li
                aria-labelledby={`Sort by ${option.label}`}
                key={`sort-option-${option.value}`}
                className={bem('option', [], sortByBaseClass, [
                  sortByState === option.value ? 'active' : '',
                ])}
                onClick={() => {
                  setSortByState(option.value);
                  setMenuState(false);
                }}
                onKeyDown={(e) => {
                  if (
                    (e.key === 'Enter' && e.keyCode === 13) ||
                    (e.key === ' ' && e.keyCode === 32)
                  ) {
                    e.preventDefault();
                    setSortByState(option.value);
                    setMenuState(false);
                  }
                }}
                role="button"
                tabIndex={0}
              >
                {option.label}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default SortBy;
